module.exports = __webpack_public_path__ + "static/media/minus.d8a4eefe.svg";